export const HistoryFallback = { SYSTEM: 'Lender System', SYSTEM_EMAIL: 'admin@lender.com' };
